import { SortingState } from "@tanstack/react-table";
import { Axios } from "api/axios";
import TableContainer from "Common/TableContainer";
import LoaderErrorWrapper from "Components/LoaderErrorWrapper/LoaderErrorWrapper";
import { CategoryActionMenu } from "Components/MenuActionButton/CategoryActionButton";
import SearchBox from "Components/SearchBox/SearchBox";
import { app_modules } from "helpers/apps_modules_list";
import { Fragment, useEffect, useMemo, useRef, useState } from "react";
import {
  Button,
  Card,
  Col,
  Container,
  Form,
  Modal,
  Row,
  Spinner,
} from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";
import { createSelector } from "reselect";
import { fetchLatestPermissions } from "slices/auth/login/thunk";
import { fetchCategories as OnfetchCategorys } from "slices/category/thunk";
import Swal from "sweetalert2";
const Category = () => {
  document.title = "Category List";
  const dispatch = useDispatch<any>();

  // Redux selector for category state
  const selectCategorys = createSelector(
    (state: any) => state.Category,
    (category) => ({
      categories: category.categoryList,
      rowCount: category.rowCount,
      loading: category.loading,
      error: category.error,
    })
  );

  const { categories, rowCount, loading, error } = useSelector(selectCategorys);

  const user = useSelector((state: any) => state.Login.user);
  const user_permissions = user?.permissions || [];
  const master_permissions = user_permissions?.find(
    (item: any) => item?.apps_name === app_modules?.master?.app_name
  );
  const category_permissions = master_permissions?.modules_permissions?.find(
    (item: any) => item?.modules_name === app_modules?.master?.modules?.category
  );

  console.log(category_permissions);

  const [showModal, setShowModal] = useState(false);
  const [configureCategoryName, setConfigureCategoryName] = useState("");
  const [configureCategoryId, setConfigureCategoryId] = useState("");
  const [web, setWebValue] = useState("");
  const [system, setSystemValue] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  //*// Fetch permissions
  useEffect(() => {
    const fetchPermissions = async () => {
      try {
        await dispatch(fetchLatestPermissions()).unwrap();
      } catch (error) {
        console.error("Failed to fetch latest permissions", error);
      }
    };
    fetchPermissions();
  }, [dispatch]);

  //*// For redirecting back to this page and get the same paginated pageIndex
  const [searchParams, setSearchParams] = useSearchParams();
  const pageParam = parseInt(searchParams.get("page_category") || "0");

  const [pageIndex, setPageIndex] = useState(pageParam);

  // Save current page to sessionStorage when component mounts
  useEffect(() => {
    if (pageParam > 0) {
      sessionStorage.setItem("categoryPage", pageParam.toString());
    } else {
      // Clear sessionStorage when navigating from sidebar (page 0)
      sessionStorage.removeItem("categoryPage");
    }
  }, [pageParam]);
  const [pageSize, setPageSize] = useState(10);
  const [data, setData] = useState([]);
  const [totalRecords, setTotalRecords] = useState(rowCount);
  const [isStatusUpdateLoading, setIsStatusUpdateLoading] =
    useState<boolean>(false);

  // State for edit functionality
  const [editCategory, setEditCategory] = useState<boolean>(false);
  const [columnFilters, setColumnFilters] = useState<any>();
  const [edit, setEdit] = useState<any>();
  const [sorting, setSorting] = useState<SortingState>([]);
  const [searchInput, setSearchInput] = useState("");
  const [search, setSearch] = useState("");
  const [filterValue, setFilterValue] = useState<any[]>([]);
  const sortField = sorting[0]?.id ?? "";
  const sortDirection = sorting[0]?.desc ? "desc" : "asc";
  const navigate = useNavigate();
  useEffect(() => {
    dispatch(
      OnfetchCategorys({
        page: pageIndex + 1,
        pageSize,
        sort: sortField,
        order: sortField ? sortDirection : "",
        search,
        filters: filterValue,
      })
    );
  }, [
    dispatch,
    pageIndex,
    pageSize,
    sorting,
    search,
    sortField,
    sortDirection,
  ]);

  const prevFilters = useRef(filterValue);

  useEffect(() => {
    if (JSON.stringify(prevFilters.current) !== JSON.stringify(filterValue)) {
      prevFilters.current = filterValue;
      dispatch(
        OnfetchCategorys({
          page: 1, // Always use page 1 when filters change
          pageSize,
          sort: sortField,
          order: sortField ? sortDirection : "",
          search,
          filters: filterValue,
        })
      );
    }
  }, [filterValue]);

  useEffect(() => {
    setData(categories);
  }, [categories]);

  // Sync pageIndex with URL parameters
  useEffect(() => {
    const currentPageParam = parseInt(searchParams.get("page_category") || "0");
    if (currentPageParam !== pageIndex) {
      setPageIndex(currentPageParam);
    }
  }, [searchParams, pageIndex]);

  //*// All pagination Issues(resolved) when redirecting from the edit or view page
  // Reset pagenumber to 0 when not first render
  const isFirstRender = useRef(true);
  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    handlePageChange(0);
  }, [sorting, pageSize, columnFilters, search]);
  const handlePageChange = (newPage: number) => {
    setPageIndex(newPage);
    setSearchParams({ page_category: newPage.toString() });
    // Save current page to sessionStorage for back navigation
    sessionStorage.setItem("categoryPage", newPage.toString());
  };
  // Debounced search
  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      setSearch(searchInput);
    }, 500);

    return () => clearTimeout(delayDebounce);
  }, [searchInput]);
  //*//

  //*// Fetch Permissions
  useEffect(() => {
    const fetchPermissions = async () => {
      try {
        await dispatch(fetchLatestPermissions()).unwrap();
      } catch (error) {
        console.error("Failed to fetch latest permissions", error);
      }
    };
    fetchPermissions();
  }, [dispatch]);

  // Handle edit action
  const handleEdit = (item: any) => {
    setEditCategory(!editCategory);
    setEdit({
      id: item.id,
      categoryName: item.category_name,
      state: item.state_name,
      status: item.is_active,
      createdBy: item.created_by,
      updatedBy: item.updated_by,
      createDate: item.created_at,
      updatedDate: item.updated_at,
    });
  };

  const handleStatusToggle = async (pkg: any) => {
    try {
      const updatedStatus = !pkg.status;
      const updatedCategory = {
        category_id: pkg.category_id,
        status: updatedStatus,
      };
      const payload = { status: updatedCategory.status };
      setIsStatusUpdateLoading(true);
      const response: any = await Axios.patch(
        `api/category/edit-status/${updatedCategory.category_id}/`,
        payload
      );
      toast.success(
        `Category ${updatedStatus ? "activated" : "deactivated"} successfully`
      );

      dispatch(
        OnfetchCategorys({
          page: pageIndex + 1,
          pageSize,
          sort: sortField,
          order: sortField ? sortDirection : "",
          search,
          filters: filterValue,
        })
      );
    } catch (err: any) {
      toast.error("Failed to update status");
    } finally {
      setIsStatusUpdateLoading(false);
    }
  };

  const formatDate = (dateString?: string) => {
    if (!dateString) return "N/A";
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };

  const handleConfigureCategory = async (categoryId: any, payload: any) => {
    setIsSubmitting(true);

    try {
      let response: any = await Axios.patch(
        `api/item/update-percentages/${categoryId}/`,
        payload
      );
      toast.success("Category configured successfully");

      setWebValue("");
      setSystemValue("");

      dispatch(
        OnfetchCategorys({
          page: pageIndex + 1,
          pageSize,
          sort: sortField,
          order: sortField ? sortDirection : "",
          search,
          filters: filterValue,
        })
      );
    } catch (err: any) {
      console.log(err);
    } finally {
      setIsSubmitting(false);
    }

    setShowModal(false);
  };

  const handleModalOpen = (
    categoryName: string,
    categoryId: string,
    payload: any
  ) => {
    setConfigureCategoryName(categoryName);
    setConfigureCategoryId(categoryId);
    setWebValue(payload.web_per);
    setSystemValue(payload.system_per);
    setShowModal(true);
  };

  const DynamicAction = useMemo(
    () => [
      {
        header: "Action",
        enableColumnFilter: false,
        enableSorting: false,
        cell: ({ row }: { row: any }) => {
          return (
            <CategoryActionMenu
              row={row}
              canEdit={
                category_permissions?.permissions?.Update &&
                !row.original.is_mandatory
              }
              canConfigure={category_permissions?.permissions?.Update}
              openModal={handleModalOpen}
            />
          );
        },
      },
    ],
    []
  );

  const columns =
    // useMemo(
    //   () =>
    [
      // {
      //   header: "Sr. No.",
      //   id: "sr_no", // important: since there's no accessorKey
      //   enableSorting: false,
      //   enableColumnFilter: false,
      //   cell: ({ row }: { row: any }) => {
      //     return row.index + 1 + pageIndex * pageSize;
      //   },
      // },
      {
        header: "Category",
        accessorKey: "category_name",
        enableColumnFilter: true,
        enableSorting: true,
        filterType: "dropdown" as const,
        filterFetchUrl:
          "/api/category/column-filter-dropdown/?column_filter=category_name",
      },
      {
        header: "Status",
        accessorKey: "status",
        enableColumnFilter: false,
        enableSorting: false,
        cell: ({ row }: { row: any }) => {
          const pkg = row.original;
          return (
            <div
              style={{ fontSize: "1.5rem", cursor: "pointer" }}
              onClick={() => {
                if (row.original.is_mandatory) {
                  Swal.fire({
                    text: "You cannot change the status of a mandatory category.",
                    icon: "warning",
                    confirmButtonText: "Okay!",
                    confirmButtonColor: "#d33",
                    width: "250px",
                    padding: "0.5rem",
                    customClass: {
                      popup: "swal2-sm-popup",
                      confirmButton: "swal2-sm-btn",
                    },
                  });
                } else {
                  handleStatusToggle(pkg);
                }
              }}
            >
              <i
                className={`bi ${
                  pkg.status
                    ? "bi-toggle-on text-primary"
                    : "bi-toggle-off text-danger"
                }`}
                // style={{ color: "#0073BB" }}
              />
            </div>
          );
        },
      },
      {
        header: "Created By/Date",
        accessorKey: "created_at",
        enableColumnFilter: true,
        enableSorting: true,
        filterType: "date" as const,
        cell: ({ row }: { row: any }) => {
          const name = row.original.created_by_name ?? "N/A";
          const date = formatDate(row.original.created_at);
          return `  ${name}  -  ${date}  `; // extra spaces for visual padding
        },
      },
      {
        header: "Updated By/Date",
        accessorKey: "updated_at",
        enableColumnFilter: true,
        enableSorting: true,
        filterType: "date" as const,
        cell: ({ row }: { row: any }) => {
          const name = row.original.updated_by_name ?? "N/A";
          const date = formatDate(row.original.updated_at);
          return `  ${name}  -  ${date}  `; // spaces before/after the name
        },
      },
      ...DynamicAction,
    ];

  return (
    <Fragment>
      <div className="page-content">
        <Container fluid>
          <Row id="invoiceList">
            <Col lg={12}>
              <Card>
                <Card.Header>
                  <Row className="align-items-center g-2">
                    <Col lg={3} className="me-auto">
                      <h6 className="card-title mb-0">Category</h6>
                    </Col>

                    {/* Search Input Box (reusable)*/}
                    <Col xl={2} md={3}>
                      <SearchBox
                        value={searchInput}
                        onChange={setSearchInput}
                      />
                    </Col>

                    <Col className="col-md-auto">
                      <div className="hstack gap-2">
                        <Button
                          className="btn btn-subtle-danger d-none"
                          id="remove-actions"
                        >
                          <i className="ri-delete-bin-2-line"></i>
                        </Button>
                        {category_permissions?.permissions?.Create === true && (
                          <Link to="/add-category" className="btn btn-primary">
                            <i className="bi bi-plus-circle align-baseline me-1"></i>{" "}
                            Add Category
                          </Link>
                        )}
                      </div>
                    </Col>
                  </Row>
                </Card.Header>
                <Card.Body className="mt-3">
                  <LoaderErrorWrapper loading={loading} error={error}>
                    <TableContainer
                      columns={columns}
                      data={data}
                      totalRecords={rowCount}
                      pageIndex={pageIndex}
                      pageSize={pageSize}
                      // onPageChange={setPageIndex}
                      onPageChange={handlePageChange} // for persisted pagination across pages
                      onPageSizeChange={setPageSize}
                      columnFilters={columnFilters}
                      setColumnFilters={setColumnFilters}
                      sorting={sorting}
                      onSortingChange={setSorting}
                      isBordered={false}
                      isPagination={true}
                      isGlobalFilter={false}
                      SearchPlaceholder="Search categories..."
                      manualSorting={true}
                      colValue={setFilterValue}
                    />
                  </LoaderErrorWrapper>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>

      {/* Configure Category Modal */}
      <Modal
        show={showModal}
        onHide={() => {
          setShowModal(false);
          setWebValue("");
          setSystemValue("");
        }}
        centered
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>Configure {configureCategoryName}</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Row className="g-3">
            {/* WEB Value */}
            <Col xs={12} lg={6}>
              <Form.Group>
                <Form.Label>%WEB Value</Form.Label>
                <Form.Control
                  type="number"
                  min="0"
                  placeholder="Enter %web"
                  value={web}
                  onChange={(e) => {
                    const value = e.target.value;
                    // Allow empty for clearing the field
                    if (value === "" || Number(value) >= 0) {
                      setWebValue(value);
                    }
                  }}
                  onBlur={(e) => {
                    // On blur, if negative, reset to empty
                    if (e.target.value !== "" && Number(e.target.value) < 0) {
                      setWebValue("");
                    }
                  }}
                />
              </Form.Group>
            </Col>

            {/* System Value */}
            <Col xs={12} lg={6}>
              <Form.Group>
                <Form.Label>%System Value</Form.Label>
                <Form.Control
                  type="number"
                  min="0"
                  placeholder="Enter %system"
                  value={system}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (value === "" || Number(value) >= 0) {
                      setSystemValue(value);
                    }
                  }}
                  onBlur={(e) => {
                    if (e.target.value !== "" && Number(e.target.value) < 0) {
                      setSystemValue("");
                    }
                  }}
                />
              </Form.Group>
            </Col>
          </Row>
        </Modal.Body>

        <Modal.Footer className="justify-content-center">
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Cancel
          </Button>
          <Button
            variant="primary"
            disabled={!web.trim() || !system.trim() || isSubmitting}
            onClick={() =>
              handleConfigureCategory(configureCategoryId, {
                web_per: web,
                system_per: system,
              })
            }
          >
            {isSubmitting ? (
              <>
                <Spinner size="sm" className="me-2" />
                Updating...
              </>
            ) : (
              "Update"
            )}
          </Button>
        </Modal.Footer>
      </Modal>
    </Fragment>
  );
};

export default Category;
